import { get, patch } from "../client";

export interface Notification {
  id: string;
  userId: string | null;
  targetRole: string | null;
  type: string;
  priority: "low" | "normal" | "high" | "urgent";
  title: string;
  message: string;
  actionUrl: string | null;
  actionLabel: string | null;
  referenceType: string | null;
  referenceId: string | null;
  metadata: Record<string, any> | null;
  icon: string | null;
  color: string | null;
  isRead: boolean;
  readAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  success: boolean;
  data: Notification[];
  unreadCount: number;
}

export async function getNotifications(options?: {
  limit?: number;
  unreadOnly?: boolean;
  type?: string;
}): Promise<NotificationsResponse> {
  const params: Record<string, string> = {};
  if (options?.limit) params.limit = options.limit.toString();
  if (options?.unreadOnly) params.unreadOnly = "true";
  if (options?.type) params.type = options.type;

  return get<NotificationsResponse>("/admin/notifications", params);
}

export async function getUnreadCount(): Promise<number> {
  const response = await get<{ success: boolean; unreadCount: number }>(
    "/admin/notifications/unread-count"
  );
  return response.unreadCount;
}

export async function markAsRead(notificationId: string): Promise<void> {
  await patch(`/admin/notifications/${notificationId}/read`);
}

export async function markAllAsRead(): Promise<number> {
  const response = await patch<{
    success: boolean;
    markedCount: number;
  }>("/admin/notifications/mark-all-read");
  return response.markedCount;
}
